import { Injectable, ErrorHandler } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@reenstudio/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InstantChartApiService {
  params: any = {};
  apiUrl = environment.api;
  apiHeaders = environment.apiHeaders;
  constructor(private http: HttpClient) {}

  getIstant(cer_id: number | null, site_id: number | null): Observable<any> {
    const IstantApiUrl = `${this.apiUrl}/realtime/instant`;

    if (cer_id) {
      this.params.cer_id = cer_id;
    }
    if (site_id) {
      this.params.site_id = site_id;
    }

    return this.http.get(IstantApiUrl, {
      headers: this.apiHeaders,
      params: this.params,
    });
  }
}
